import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { APP_LEAVING } from '../../constants/ActionTypes';
import CTModal from '../helpers/CTModal';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import HotelGenericPropertyValue from './HotelGenericPropertyValue';

class ModalGenericPropertyValues extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hotels: get(this.props, 'hotelList'),
            searchFor: ''
        };
    }

    componentDidMount() {
        document.addEventListener('keydown', e => this._closeModal(e));
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(get(nextProps, 'hotelList'), get(this.props, 'hotelList'))) {
            this.setState({ hotels: get(nextProps, 'hotelList') });
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', e => this._closeModal(e));
    }

    _closeModal = e => {
        const KEYCODES = {
            ESCAPE: 27
        };

        if (e.keyCode === KEYCODES.ESCAPE) {
            this.props.close();
        }
    };

    _onClose = () => {
        this.props.close();
    };

    _onSearch = e => {
        this.setState({ searchFor: e.target.value.toLowerCase() });
    };

    render() {
        const { hotels } = this.state;
        let dataToDisplay = hotels;
        if (this.state.searchFor) {
            dataToDisplay = dataToDisplay.filter(
                item => `${item.name} ${item.id}`.toLowerCase().indexOf(this.state.searchFor) >= 0
            );
        }

        return (
            <div className="btn-modal-generic-property-values">
                <button
                    className="spark-btn spark-btn--sm align-middle spark-btn--secondary"
                    type="button"
                    onClick={() => {
                        this.props.openModal();
                    }}
                >
                    <icon className="spark-icon spark-icon-hotel spark-icon--lg" />
                </button>
                <CTModal
                    open={this.props.open}
                    primaryButton={true}
                    primaryButtonTitle="Apply Changes"
                    primaryButtonClick={() => this._onClose()}
                    onClose={() => this._onClose()}
                    secondaryButton={true}
                    secondaryButtonClick={() => this._onClose()}
                    secondaryButtonTitle="Cancel"
                    genericPropertyValueModal={true}
                >
                    <div>
                        <div>
                            <div className="row asset-browser--search top-header-generic-property-values">
                                <div className="col-xs-8 header-generic-property-values">
                                    Property Values:{' '}
                                    <span className="header-generic-property-config-name">
                                        {get(this.props, 'configName')}
                                    </span>
                                </div>
                                <div className="col-xs-4">
                                    <label
                                        className="spark-input"
                                        ref={node => {
                                            this.serachInputRef = node;
                                        }}
                                    >
                                        <input
                                            onChange={event => this._onSearch(event)}
                                            className="spark-input__field"
                                            name="search-for-a-hotel"
                                            role="textbox"
                                        />
                                        <span className="spark-label">Search Using Property ID or Property Name</span>
                                        <div className="spark-input__addon">
                                            <i className="spark-icon-search spark-icon--md"></i>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            <hr className="header-table-generic-property-modal-hr" />
                            <div className="header-table-generic-property-modal">
                                <div className="header-table-propertyId-name">
                                    <div className="header-table-propertyId">Property ID</div>
                                    <div className="header-table-property-name">Property Name</div>
                                </div>
                                <div className="row spark-toggle-group header-table-showall-edited-buttons">
                                    <label className="col-xs-7 spark-toggle">
                                        <input
                                            className="spark-toggle__input"
                                            type="radio"
                                            name="test-toggle-c"
                                            checked="checked"
                                        />
                                        <span className="spark-label">SHOW ALL</span>
                                    </label>
                                    <label className="col-xs-7 spark-toggle">
                                        <input className="spark-toggle__input" type="radio" name="test-toggle-c" />
                                        <span className="spark-label">EDITED</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div
                            className={classNames('main-content-generic-property-modal', {
                                ['generic-property-modal-no-hotels-found']: isEmpty(dataToDisplay)
                            })}
                        >
                            {isEmpty(dataToDisplay) && (
                                <div>
                                    <i className="spark-icon-search spark-icon--md spark-margin-right-6"></i>No hotels
                                    matched your search
                                </div>
                            )}
                            {dataToDisplay &&
                                dataToDisplay.map((hotel, index) => (
                                    <HotelGenericPropertyValue hotel={hotel} key={index} />
                                ))}
                        </div>
                    </div>
                </CTModal>
            </div>
        );
    }
}

ModalGenericPropertyValues.defaultProps = {
    open: false
};

ModalGenericPropertyValues.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired
};

export const SHOW_MODAL_GENERIC_PROPERTY_VALUES = 'SHOW_MODAL_GENERIC_PROPERTY_VALUES';
export const HIDE_MODAL_GENERIC_PROPERTY_VALUES = 'HIDE_MODAL_GENERIC_PROPERTY_VALUES';

const initialState = {
    isOpened: false
};

export const modalGenericPropertyValuesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_MODAL_GENERIC_PROPERTY_VALUES:
            return {
                isOpened: true
            };
        case HIDE_MODAL_GENERIC_PROPERTY_VALUES:
        case APP_LEAVING:
            return {
                isOpened: false
            };
        default:
            return state;
    }
};

export const modalGenericPropertyValuesActions = {
    show() {
        return dispatch => {
            dispatch({ type: SHOW_MODAL_GENERIC_PROPERTY_VALUES });
        };
    },
    hide() {
        return dispatch => {
            dispatch({ type: HIDE_MODAL_GENERIC_PROPERTY_VALUES });
        };
    }
};

const mapStateToProps = state => {
    return {
        open: state.app.modal.genericPropertyValues.isOpened,
        app: state.app,
        code: state.app.data.configuration.configuration.configCode,
        selectedLevel: state.app.selected.level,
        hotelList: get(state, 'manage.hotelList')
    };
};

const mapDispatchToProps = dispatch => ({
    close: () => dispatch(modalGenericPropertyValuesActions.hide()),
    openModal: () => dispatch(modalGenericPropertyValuesActions.show())
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalGenericPropertyValues);



// WEBPACK FOOTER //
// ./src/components/modals/ModalGenericPropertyValues.js